module.exports = __webpack_public_path__ + "static/media/IMG_7294-min.ca424fd3.jpg";